/**
 * Created by tiedong on 2017/7/19.
 */
import * as types from '../constants/ActionTypes'
import api from '../../utils/api'
import { message } from 'antd';

let selectedReport = (data) => {
    return {
        type: types.SELECTED_REPORT,
        payload: { data: data }
    }
}


let createOrUpdateReport = (data, agentId = '') => {
    var url = "/lossAss/newReport?agentId=" + agentId
    return dispatch => {
        return api(url)
            .post(data)
            .then(result => dispatch(createOrUpdateReportFinish(result)))
            .catch(err => dispatch(createOrUpdateReportFinish({ errCode: -1 })))
    }
}
let createOrUpdateReportFinish = (result) => {
    if (result.errCode == 0) {
        return {
            type: types.GET_LATEST_REPORT_FINISH,
            payload: {
                result: result.result,
                errCode: 0
            }
        }
    } else {
        return {
            type: types.GET_LATEST_REPORT_FINISH,
            payload: result,
            error: true
        }
    }
}



let showEvaluation = (data, flowId) => {
    if (data && flowId) {

        api('/lossAss/report/evaluation').post({ flowId, evalScore: data })
    } else console.log("enter showEvaluation 0")
    return {
        type: types.SHOW_EVALUATION,
        payload: data
    }
}


// 太保照片分类
let cpic_classify_pics = (data) => {
    let url = '/lossAss/superView/pics/classify';
    return dispatch => {
        return api(url).put(data).then(result => dispatch(cpic_classify_pics_finish(result)))
            .catch(err => dispatch(cpic_classify_pics_finish({ errCode: -1 })))
    }
}

let cpic_classify_pics_finish = (data) => {

    if (data.errCode == 0) {
        return {
            type: types.CPIC_CLASSIFY_PICS_FINISH,
            payload: data.result
        }
    } else {
        return {
            type: types.CPIC_CLASSIFY_PICS_FINISH,
            payload: {},
            error: true
        }
    }
}

// 领取任务工单
const acceptReport = (record, agentId) => {
    const url = `/lossAss/report/agentaccept?flowId=${record && record.flowId || ''}&agentId=${agentId || ''}`;
    return dispatch => {
        return api(url).get().then(res => {
            if (res.errCode == 0) {
                message.success('接收任务成功');
                return dispatch({
                    type: types.AGENT_ACCEPT_REPORT_FINISH,
                    payload: res.result,
                });
            } else {
                message.error(res.errInfo);
                return dispatch({
                    type: types.AGENT_ACCEPT_REPORT_FAILED,
                    error: true,
                });
            }
        }).catch(err => {
            message.error('接收任务失败，请稍后重试');
        });
    }
}
// 定损坐席领取定损任务
const acceptDefLossTask = (record, agentId) => {
    const url = `/lossAss/deflossTask/agentAccept?flowId=${record && record.flowId || ''}&agentId=${agentId || ''}`;
    return dispatch => {
        return api(url).get().then(res => {
            if (res.errCode == 0) {
                message.success('接收定损任务成功');
                return dispatch({
                    type: types.AGENT_ACCEPT_REPORT_FINISH,
                    payload: res.result,
                });
            } else {
                message.error(res.errInfo);
                return dispatch({
                    type: types.AGENT_ACCEPT_REPORT_FAILED,
                    error: true,
                });
            }
        }).catch(err => {
            message.error('接收定损任务失败，请稍后重试');
        });
    }
}

// 修改案件状态， 已定损/已结案
const resetReportStateByAgent = ({ flowId, state, subState, agentId }) => {
    const url = `/lossAss/cpic/tpa/report/resetState?flowId=${flowId || ''}&state=${state || ''}&subState=${subState || ''}&agentId=${agentId}`;
    return dispatch => {
        return api(url).get().then(res => {
            const businessFailed = res
                && res.result
                && typeof res.result.success === 'boolean'
                && res.result.success === false;
            if (res.errCode == 0 && !businessFailed) {
                message.success('操作成功');
                dispatch({
                    type: types.RESET_REPORT_STATE_SUCCESS,
                    payload: res.result,
                });
                return {
                    success: true,
                    result: res.result,
                };
            } else {
                let errMsg = '操作失败，请稍后重试';
                switch (res.errCode) {
                    case 500:
                        errMsg = errMsg;
                        break;
                    default: errMsg = res.errInfo;
                }
                if (businessFailed && res.result && res.result.errInfo) {
                    errMsg = res.result.errInfo;
                }
                message.error(errMsg);
                dispatch({
                    type: types.RESET_REPORT_STATE_FAILED,
                    error: true,
                });
                return {
                    success: false,
                    errInfo: errMsg,
                    result: res.result,
                };
            }
        }).catch(err => {
            message.error('操作失败，请稍后重试');
        });
    }
}

// 发送定损预览给用户
const sendDeflossPreview = ({ flowId, agentId }) => {
    const url = `/lossAss/cpic/tpa/deflossPreview/send?flowId=${flowId || ''}&agentId=${agentId}`;
    return dispatch => {
        return api(url).get().then(res => {
            if (res.errCode == 0) {
                message.success('操作成功');
                return {
                    type: types.SEND_DEFLOSS_PREVIEW_SUCCESS,
                    payload: res.result,
                };
            } else {
                let errMsg = '操作失败，请稍后重试';
                switch (res.errCode) {
                    case -2:
                    case -3:
                        errMsg = res.errInfo;
                        break;
                    default: errMsg = errMsg;
                }
                message.error(errMsg);
                return {
                    type: types.SEND_DEFLOSS_PREVIEW_FAILED,
                    error: true,
                };
            }
        }).catch(err => {
            message.error('操作失败，请稍后重试');
        });
    }
}


const setReturnedModal = ({ isShow = false, returnType = '', nextTime, followDetails, }) => {
    return dispatch => {
        // const data = { isShowReturnedModal: isShow, nextTime, followDetails };
        // if (returnType) {
        //     data.returnType = returnType;
        // }
        // return dispatch({
        //     type: types.SET_RETURNED_MODAL,
        //     payload: data
        // });
        let data = {}
        if (followDetails && Object.keys(followDetails).length > 0) {
            data = { isShowReturnedModal: isShow, nextTime, followDetails, }
        } else {
            data = { isShowReturnedModal: isShow, nextTime, }
        }
        if (returnType) {
            data.returnType = returnType;
        }
        return dispatch({
            type: types.SET_RETURNED_MODAL,
            payload: data,
        });

    }
}


const setDeflossPreviewModal = ({ isShow = false }) => {
    return dispatch => {
        return dispatch({
            type: types.SET_DEFLOSS_PREVIEW_MODAL,
            payload: { isDeflossPreviewModal: isShow }
        });
    }
}

const getUploadFailureReason = (resData = {}) => {
    const errCode = typeof resData.errCode === 'number' ? resData.errCode : '';
    const reasonMap = {
        'Something broke!': '服务端接收图片时发生异常，可能是图片转换后的请求超过20MB限制',
        '内部服务错误': '图片上传服务暂时不可用，可能是消息队列连接中断',
    };
    const errInfo = reasonMap[resData.errInfo] || resData.errInfo || '服务端未返回具体原因';
    return errCode === '' ? errInfo : `${errInfo}（错误码：${errCode}）`;
}

const getUploadRequestFailure = async (err) => {
    const response = err && err.response;
    if (!response) {
        return {
            failureReason: `网络连接异常或请求被中断${err && err.message ? `：${err.message}` : ''}`,
        };
    }

    const status = response.status;
    let responseData = {};
    try {
        responseData = await response.clone().json();
    } catch (parseError) {
        // 网关错误页通常不是 JSON，继续使用 HTTP 状态生成提示。
    }

    if (responseData && responseData.errInfo) {
        return {
            failureReason: `${responseData.errInfo}（HTTP ${status}）`,
            httpStatus: status,
        };
    }

    const statusReasons = {
        400: '上传请求参数错误',
        401: '登录状态已失效',
        403: '没有图片上传权限',
        413: '图片转换后的请求数据过大，超过网关或服务端限制',
        502: '上传网关暂时不可用',
        503: '上传服务暂时不可用',
        504: '上传请求超时',
    };
    return {
        failureReason: `${statusReasons[status] || response.statusText || '上传请求失败'}（HTTP ${status}）`,
        httpStatus: status,
    };
}

const uploadPicSuccess = (resData, uid) => {
    const serverResult = resData && resData.result || {};
    const result = { ...serverResult, uid: serverResult.uid || uid };
    if (resData && resData.errCode == 0) {
        return {
            type: types.UPLOAD_PIC_SUCCESS,
            payload: { result },
            error: false
        };
    } else {
        const failureReason = getUploadFailureReason(resData);
        message.error(failureReason)
        return {
            type: types.UPLOAD_PIC_FAILED,
            payload: { result: { ...result, failureReason } },
            error: true
        };
    }
}
const uploadPicFailed = (uid, errorInfo = {}) => {
    return {
        type: types.UPLOAD_PIC_FAILED,
        payload: { result: { uid, ...errorInfo } },
        error: true
    };
}
const uploadPic = ({ image = '', flowId = '', lossId = '', label = '', subLabel = '', agentId = '' , isDone, ...props}) => {

    if (!image || !flowId) return;
    return dispatch => {
        return api('/lossAss/shotPics')
            .post({
                flowId,
                image,
                lossId,
                label,
                subLabel,
                agentId,
                referer: "agent",
                isDone,
                ...props
            })
            .then(resData => dispatch(uploadPicSuccess(resData, props.uid)))
            .catch(async err => {
                const errorInfo = await getUploadRequestFailure(err);
                return dispatch(uploadPicFailed(props.uid, errorInfo));
            })
    }
}
const searchBanksSuccess = (resData) => {
    if (resData && resData.errCode == 0) {
        return {
            type: types.SEARCH_BANKS_SUCCESS,
            payload: { result: resData.result },
        }
    } else {
        return {
            type: types.SEARCH_BANKS_FAILED,
            payload: { result: resData.result },
            error: true
        }
    }
}

const searchBanks = ({ bankName = '', bankCode = '' }, source) => {

    // const urlMap = {
    //     'CpicReportDetailFoot': '/banks',
    //     'HLReportDetailFoot': '/accountBanks/ccic',
    // }
    // const url = urlMap[source]
   
    const url = source === 'HLReportDetailFoot' ? '/banks/ccic' : '/banks'
    const params = source === 'HLReportDetailFoot'
        ?
        {
            kw: bankName,

        }
        :
        {
            kw: bankName,
            bankCode,
        }
    return dispatch => {
        return api(url)
            .get(params)
            .then(resData => dispatch(searchBanksSuccess(resData)))
            .catch(err => dispatch(uploadPicFailed()))
    }
}

const searchAccountBanks = ({ bankCode }) => {
    return dispatch => {
        return api('/accountBanks')
            .get({
                bankCode,
            })
            .then(resData => dispatch(searchBanksSuccess(resData)))
            .catch(err => dispatch(uploadPicFailed()))
    }
}

const createReportByAgent = (data = {}) => {
    return dispatch => {
        return api('/lossAss/report/createByAgent')
            .post(data)
            .then(resData => dispatch(getPoliciesFinished(resData)))
            .catch(err => dispatch(getPoliciesFinished({ errCode: -1 })))
    }
}

const getPoliciesFinished = (data) => {
    if (data.errCode == 0) {
        return {
            type: types.CREATE_TPA_REPORT_BY_AGENT_SUCCESS,
            payload: data
        }
    } else {
        return {
            type: types.CREATE_TPA_REPORT_BY_AGENT_FAILED,
            payload: data,
            error: true
        }
    }
}

export default {
    selectedReport,
    createOrUpdateReport,
    // uploadelectClaimsPic,
    showEvaluation,
    cpic_classify_pics,
    acceptReport,
    acceptDefLossTask,
    resetReportStateByAgent,
    sendDeflossPreview,
    setReturnedModal,
    setDeflossPreviewModal,
    uploadPic,
    uploadPicSuccess,
    uploadPicFailed,
    searchBanks,
    searchAccountBanks,
    createReportByAgent,
}
